import React, { useEffect } from 'react';
import { useContext, useState } from 'react';
import { UserContext } from '../../../../../../../context/UserContext';
import { IntegrationSettingsInput } from '../../../../../../../types/integration_settings';
import { ActionModalBody, ActionModalFooter } from '../../../../../../components/Modal/templates/ActionModal';
import TeamLeaderLogo from '../../../../../../../assets/img/TeamLeaderLogo.png';
import { Divider } from '../../../../../../components/Divider';
import { CancelButton } from '../../../../../../components/Button';
import { v4 } from 'uuid';

interface TeamleaderIntegrationConnectPaneProps {
  input: IntegrationSettingsInput;
  setInput: (input: IntegrationSettingsInput) => void;

  handleCancel: () => void;
}

export default function TeamleaderIntegrationConnectPane({
  input,
  setInput,
  handleCancel,
}: TeamleaderIntegrationConnectPaneProps) {
  const { currentUser } = useContext(UserContext);

  const [link, setLink] = useState<string>('');

  const authorizeTeamLeader = async () => {
    if (!currentUser?.id) return;

    const id = v4();
    const url = 'https://focus.teamleader.eu/oauth2/authorize';
    const clientId = process.env.REACT_APP_TEAMLEADER_CLIENT_ID;
    const redirectUri = encodeURIComponent(`${process.env.REACT_APP_API_BASE_URL}/api/teamleader/callback`);
    const responseType = 'code';
    const state = encodeURIComponent(JSON.stringify({ companyId: input.companyId, userId: currentUser.id, id }));

    const link = `${url}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&state=${state}`;

    window.open(link, '_blank');

    setLink(link);
    if (!input.id) setInput(input.withId(id));
  };

  useEffect(() => {
    if (link) return;
    authorizeTeamLeader();
  }, []);

  return (
    <>
      <ActionModalBody>
        <div className='flex flex-col items-center gap-2'>
          <div className='h-[350px] w-[350px]'>
            <img src={TeamLeaderLogo} />
          </div>
          <p>{'Connecting...'}</p>
        </div>
      </ActionModalBody>
      <Divider />
      <ActionModalFooter>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={handleCancel} />
        </div>
      </ActionModalFooter>
    </>
  );
}
